(function($) {
  
	function custom_mailchimp_subscribe() {
		var success = true;	
		if($('#custom-create-input').prop('checked')) {
			$('#custom-go-group input[type="checkbox"]').attr('checked', true);
            $('#custom-go-group input[type="checkbox"]').prop('checked', true);
			var showcustomeremail = $('#create_customer input[name="customer[email]"]').val();
			if (showcustomeremail != '') {
				$('#custom-go-group input#mce-EMAIL').val(showcustomeremail);
			}
			success = true;       
		}
		else {
			$('#custom-go-group input[type="checkbox"]').attr('checked', false);
             $('#custom-go-group input[type="checkbox"]').prop('checked', false);
			$('#custom-go-group input#mce-EMAIL').val('');
			success = false;
		}
		return success; 
	}

	$(document).on('click', '#custom-create-input', function(){
      
		custom_mailchimp_subscribe();
	});
	$(document).on('click', '#create_customer input[type="submit"]', function(e){
      
		if(custom_mailchimp_subscribe() == true)
		{
			e.preventDefault();
			setTimeout(function(){
				document.getElementById('create_customer').submit();
			}, 2000);
		}
		$('div#custom-go-group input#mc-embedded-subscribe').click();
	});
  
    $(document).ready(function ($) {
      var cookiebar = setInterval(function(){
        if($("body").length > 0){
          if($('#accept-cookies').is(':visible')){
              $("body").addClass("show-cookie-bar");
          }
        else {
          $("body").removeClass("show-cookie-bar");
        }
      }
      });
      
      var activeparent = setInterval(function(){
        if($(".view-mode").length > 0){
          if($('.view-mode .view-as .icon-mode').hasClass('active')){
              $('.view-mode .view-as .icon-mode.active').parent().addClass("active-parent");
          }
        else {
          
        }
      }
      });
        $(document).on('click', '.view-mode .view-as', function(e){
			e.preventDefault();
          	
          var self = $(this),
                    parents = self.closest('[data-view-as]');
          
          if (!self.hasClass('active')) {
            parents.find('.view-as').removeClass('active-parent');
            self.find('.view-as').addClass('active-parent');
          };
          
        });
      
     var slidequnty = setInterval(function(){
      
      if($('.template-product .product-img-box .slider-nav .slick-track > .item').length > 0 ) {
      	$('.template-product .product-img-box .slider-nav .slick-track > .item').parent().parent().parent().parent().hide();
        $('.template-product .vertical-moreview').addClass('adjust-width');
      }
      });
      
     });
  
    $(document).ready(function(){
      
      $(document).on('click', '.product-shop .spr-badge', function(){
          $('html, body').animate({
              scrollTop: $(".tabs__product-page").offset().top
          }, 2000);
          $('.tabs__product-page .list-tabs .tab-links[data-target="#collapse-tab1"]').removeClass('active');
          $('.tabs__product-page .list-tabs .tab-links[data-target="#collapse-tab2"]').addClass('active');
          $('div#collapse-tab1').removeClass('active');
          $('div#collapse-tab2').addClass('active');
      });
      
      
      var val = localStorage.getItem('qus');
      var radios = document.getElementsByName("qus");
      var val = localStorage.getItem('qus');
      if ($(".login-page.custom-acc-page").length > 0){
      	
        if(val == null){
        //document.getElementById("yes").checked = true;
         localStorage.setItem('inputValue', 'yes');
        
      }else{
      	for(var i=0;i<radios.length;i++){
          if(radios[i].value == val){
            radios[i].checked = true;
          }
        }
      }
        
      }
      
       var errorMsg = localStorage.getItem('errorMsg');
      
       if(errorMsg != null ){
         $('.errors ul li').text(errorMsg);
         
         let currentURL = window.location.href;
         if(currentURL.indexOf("login") !== -1){
            localStorage.removeItem('errorMsg');
            $(".lader-main").attr('style','display:none')
         	
         }else{
           
           	if(currentURL.indexOf("account") !== -1){
                localStorage.removeItem('errorMsg');
                $(".lader-main").attr('style','display:none');
            }else{
            	window.location.href = $('.account-link').find('.hl-item').attr('href');
            }
         }
       } else{
         $(".lader-main").attr('style','display:none');
       }
      
      
      
      if(val== "yes" || val == null ){
         //$('.errors ul li').text('Les identifiants de ce compte ne sont pas ceux d’un Client Entreprise. Veuillez SVP cocher la case “Je suis un Bénéficiaire d’un Client Entreprise” !');
      }
     
      
  $('input[name="qus"]').on('change', function(){
     localStorage.setItem('qus', $(this).val());
     localStorage.setItem('inputValue', $(this).val());
   });   
  

      	if($('body').hasClass('customer-logged-in'))
        {
         	var getValue = localStorage.getItem('inputValue');
          	if(getValue == 'no')
            {
              
            	$('.cutomer-detail-and-portal > .seller-portal-outer').hide();
              	$('.custom-acc-page .page-header h1').text("Mon compte Bénéficiaire");
            }
          else {
          	$('body.template-customers-order .page-header h1').text("Mon compte Entreprise");
          }
        }
      
      var form_submit = true;
      function require_form_error()
      {
        var register_email = document.getElementById('email').value;
		
        if(register_email == '')
        {
          document.getElementById('register_email_error').innerHTML = 'Le champs <b>Email</b> est obligatoire';
          form_submit = false;
        }
 		else
        {
          
        	return true;
        }
        
		
      }
      
	function password_require()
      {
		var register_pass = document.getElementById('create_password').value;
      	if(register_pass == '')
        {
          document.getElementById('register_password_error').innerHTML = 'Le champs <b>Mot de passe</b> est obligatoire';
          form_submit = false;
        }
        else
        {
          return true;
        }
       
      }
      
      function name_require()
      {
		var register_name = document.getElementById('first_name').value;
      	if(register_name == '')
        {
          document.getElementById('register_name').innerHTML = 'Le champs <b>Prénom</b> est obligatoire';
          form_submit = false;
        }
        else
        {
          return true;
        }
       
      }
      
      function lastname_require()
      {
		var register_lastname = document.getElementById('last_name').value;
      	if(register_lastname == '')
        {
          document.getElementById('register_lastname').innerHTML = 'Le champs <b>Nom</b> est obligatoire';
          form_submit = false;
        }
        else
        {
          return true;
        }
       
      }
      
      
      $("#create_customer").submit(function(e){
 		e.preventDefault();
        	require_form_error();
        	password_require();
        	name_require();
        	lastname_require();
        if(require_form_error() == true && password_require() == true && name_require() == true && lastname_require() == true)
        {
        	document.getElementById('create_customer').submit();
			
        }
      });
      
      var get_shipping_add_text = $('.shipping-address-order-page > p').text();
      
      if(get_shipping_add_text == 0 ) {
      	$('.shipping-address-order-page').addClass("hide");
      }
      
      var get_billing_add_text = $('.billing-address-order-page > p').text();
      
      if(get_billing_add_text == 0 ) {
      	$('.billing-address-order-page').addClass("hide");
      }
      
      var telephone_number = $(".billing-address-order-page > p span.mt-10").text();
      
      if((telephone_number).length > 0 ) {
      	$('.template-customers-order .grid-item span.mt-10').addClass("telphone-before");
      }
      
      
  	});
  
  
  	})(jQuery);
